import React,{useState,useEffect} from 'react'
import Template from '../Components/Template'

import 'react-quill/dist/quill.snow.css'; // Import the styles
import { useAddProductCategoryMutation, useDeleteProductCategoryMutation, useGetAllProductCategoryQuery, useUpdateProductCategoryMutation } from '../Services/modules/products';
import { MdOutlineNavigateNext,MdSkipNext,MdSkipPrevious,MdEdit, MdDelete   } from "react-icons/md";
import { GrFormPrevious } from "react-icons/gr";
import useDataTable from '../hooks/useDataTable';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { updateProductData } from '../Store/ProductData';
import WarningModal from '../Components/WarningModal';

function ProductCategory() {
  const dispatch=useDispatch()
  const navigate=useNavigate()
  const {   
    handleFirstPage ,
    handlePageSizeChange,
    handleLastPage,
    sequenceStartIndex  ,
    page,
    rowsPerPage,
    totalRows,
    setTotalRows,
    setPage,
    setTotalPages,
    totalPages
    // Add other state variables and functions here
  }=useDataTable()
    const [allProductCategories, setProductCategories] = useState([]);    
    const [isSumbmiting,setIsSubmitting]=useState(false)
    const [isUpdate,setIsUpdate]=useState("")  
    const[isDelete,setIsDelete]=useState(false) 
    const[isDeleteModal,setDeleteModal]=useState(false)
    
    const [AddProductCategory, { data, isSuccess, isLoading, isError, error }] = useAddProductCategoryMutation();

    const{data:dataProduct=[],
      isSuccess:isSuccessProduct,
      isLoading:isLoadingProduct,
      error:errorProduct,
      refetch
    }=useGetAllProductCategoryQuery()
   
    const [product_Category_data, setProductCategoryData] = useState({
        category_id:"",
        product_category: "",       
      });
    
     
      const [UpdateProductCategory, { 
        data:updateData=[], 
        isSuccess:updateIsSuccess, 
        isLoading:updateIsLoading, 
        isError:updateIsError, 
        error:updateError }] = useUpdateProductCategoryMutation();
       
        const [DeleteProductCategory, { 
          data:deleteData=[], 
          isSuccess:deleteIsSuccess, 
          isLoading:deleteIsLoading, 
          isError:deleteIsError, 
          error:deleteError }] = useDeleteProductCategoryMutation();
      function handleChange(name, value) {
        setProductCategoryData({
          ...product_Category_data,
          [name]: value
        });
      }
     
      const clearProductCategoryData=()=>{
        console.log("In clear product category")      
        setProductCategoryData({
          ...product_Category_data,
          category_name:"",      
          category_id:""   ,       
        });

      }
      const onSubmit=()=>{
        setIsSubmitting(true)
        if(!isUpdate)
        {
          AddProductCategory(product_Category_data)

        }   
         else {
      UpdateProductCategory(product_Category_data);
    }    
      }
    
      const handleProductDelete=(dataRow)=>{
       console.log("In handle product delete dataRow",dataRow)
        setDeleteModal(true)
        setProductCategoryData({
          ...product_Category_data,
          category_id:dataRow._id,         
        });

      }
  
 
  useEffect(() => {
    refetch();
  }, [page]);
  useEffect(() => {

   if(isSuccess)
   {
    setIsSubmitting(false)

    toast.success(data.message)
    clearProductCategoryData()
   // refetch()
   }
  }, [data]);

    useEffect(() => {

   if(updateIsSuccess)
   {
    setIsSubmitting(false)

    toast.success(updateData.message)
    handleCancle()
   // refetch()
   }
  }, [updateData]);

  useEffect(()=>{
console.log("In get product useeffet")
if(isSuccessProduct)
{
  console.log("dataProduct ddddd",dataProduct)
  setProductCategories(dataProduct.data)
  setTotalRows(dataProduct.totalRows)
}
  },[dataProduct])

//   useEffect(()=>{

//     if(updateIsSuccess)
//     {
//       console.log("updateddataProduct",updateData)

//       if(!updateData.error)
//       {
//         // setProducts(updateData.data)
//         // setTotalRows(updateData.totalRows)
//         toast.success(updateData.message)
//         setIsUpdate(false)
//         clearProductCategoryData()
//         setIsSubmitting(false)

//       }
//       else
//       {
//         toast.error(updateData.message)
//     clearProductCategoryData()


//       }
    
//     }
//       },[updateData])


      useEffect(()=>{

        if(deleteIsSuccess)
        {
          console.log("deleteddataProduct",deleteData)
    
          if(!deleteData.error)
          {
            // setProducts(deleteData.data)
            // setTotalRows(deleteData.totalRows)
            toast.success(deleteData.message)
            setIsDelete(false)
            setDeleteModal(false)
    clearProductCategoryData()

    //refetch()
            
          }
          else
          {
            toast.error(deleteData.message)
            setIsDelete(false)
            setDeleteModal(false)    
          }        
        }
          },[deleteData])
      useEffect(() => {
        if(isDelete)
        {
          DeleteProductCategory(product_Category_data)
        }
      
      }, [isDelete]);
      const navigateToProduct=(productCategoryDetails)=>{
        //dispatch(updateProductData({data:productDetails}))
        console.log("productCategoryDetails",productCategoryDetails)
        navigate({
          pathname: '/products',
        search: `?categoryId=${productCategoryDetails._id}&productCategoryName=${productCategoryDetails.product_category}`,    
        });
  
       }
     
       const handleEdit = (dataRow) => {
           setProductCategoryData({
             ...product_Category_data,
             category_id: dataRow._id,
             product_category: dataRow.product_category,           
           });
           setIsUpdate(true);
         };
       
         const handleCancle=()=>{
          setIsUpdate(false)
           setProductCategoryData({
             ...product_Category_data,
             category_id: "",
             product_category: "",           
           });
         }
    const productCategoryScreen=()=>{
        return(
            <>
            <ToastContainer/>
            
              <
                WarningModal
                setShowWarningModal={setDeleteModal}
                modalTitle={"Delete Product"}
                setIsDelete={setIsDelete}
                showModal={isDeleteModal}
              />
            
        <main id="main" class="main">

            <div className='container'>
              <div className='row'>
              <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Add Product Categories</h5>
             
                <div className="form-group">
                  <label htmlFor="input1">Product Category</label>
                  <input type="text" 
                  className="form-control mb-3" 
                  id="input1"
                  name="product_category"
                  value={product_Category_data.product_category}
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                   />
                </div>
               
            <button 
  type="submit" 
  className="btn btn-primary"
  onClick={() => onSubmit()}
>
  {isSumbmiting ? 
    'Submitting...' : 
    isUpdate ? 'Update' : 'Submit'} 
</button>

<button 
  type="button" 
  className="btn btn-danger ms-2" 
  onClick={() => handleCancle()}
>
  Cancel
</button>
             
            </div>
          </div>
        </div>
                <div className='col-md-6'>
                    <div className='card'>
                        <div className='card-body'>
                        <table className="bordered-table">
        <thead>
          <tr>
          <th>Action</th>
            <th>Index</th>
            <th>Product Category</th>
            {/* Add more column headers as needed */}
          </tr>
        </thead>
        <tbody>
          {allProductCategories.map((item, index) => (
            <tr key={index}>
              <td>
                  <MdEdit
                                                onClick={() => handleEdit(item)}
                                                style={{ cursor: 'pointer', marginRight: 8 }}
                                                title="Edit"
                                              />
               
              <MdDelete onClick={()=>handleProductDelete(item)} style={{cursor:'pointer'}}/>
              </td>
              <td>{sequenceStartIndex + index}</td>
              <td>
              <a onClick={()=>navigateToProduct(item)} style={{cursor:'pointer',color:'blue'}}>

                {item.product_category}
                </a>
                </td>             
            </tr>
          ))}
        </tbody>
      </table>
      <button onClick={() => handleFirstPage()} disabled={page === 0}><MdSkipPrevious/></button>
      <button onClick={() => setPage(page - 1)} disabled={page === 0}><GrFormPrevious/></button>
      <button onClick={() => setPage(page + 1)} disabled={page === totalPages - 1}><MdOutlineNavigateNext /></button>
      <button onClick={() => handleLastPage()} disabled={page === totalPages - 1}><MdSkipNext/></button>
      <div>
        <select value={rowsPerPage} onChange={handlePageSizeChange}>
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>
      
      </div>
     
                        </div>
                    </div>
                </div>
              </div>
              
             
            </div>
            </main>
            </>
        )
     
    }
  return (
    <Template>{productCategoryScreen()}</Template>
  )
}

export default ProductCategory